module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAABmwAAAZsBqMTCdgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAABfSURBVEiJY2AYBfQA////P/cfAc6QopeRRIv+o2hmZCRaPxMpFlECRi0atQi7RWj5BAOga8anFj2fMaJrpKYvkPPZgMXRSSqafRyZM1oEjVo0ahEcIOez4zhVjQJqAgA2A14suy+PSwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/plus.png
// module id = 206
// module chunks = 0